<template>
  <div>
    <Card>
      <Tabs value="name1">
        <TabPane label="未扫描" name="name1">
          <div style="text-align: right;margin-bottom: 5px;">
            <a href="#" slot="extra" @click.prevent="exportToExcel">
              <Icon type="ios-redo" />
              导出Excel
            </a>
          </div>
          <Table stripe border :columns="columns" :data="layerList" :loading="showLoading" ref="table" max-height="500"></Table>
          <Page class-name="page"
                :total="total"
                :page-size="pageSize"
                show-total
                ransfer="transfer"
                @on-change="pageNumChange"
                @on-page-size-change="onPageSizeChange"></Page>
        </TabPane>
        <TabPane label="分析失败" name="name2">
          <div style="text-align: right;margin-bottom: 5px;">
            <a href="#" slot="extra" @click.prevent="exportToExcel1">
              <Icon type="ios-redo" />
              导出Excel
            </a>
          </div>
          <Table stripe border :columns="columns" :data="layerNoList" :loading="showLoading" ref="table" max-height="500"></Table>
          <Page class-name="page"
                :total="total1"
                :page-size="pageSize1"
                show-total
                ransfer="transfer"
                @on-change="pageNumChange1"
                @on-page-size-change="onPageSizeChange1"></Page>
        </TabPane>
      </Tabs>
    </Card>
  </div>
</template>

<script>
export default {
  name: 'LayerTable',
  props: {
    caseId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      $vue: '',
      pageSize: 200,
      pageNum: 1,
      total: 200,
      pageSize1: 200,
      pageNum1: 1,
      total1: 200,
      transfer: true,
      showLoading: true,
      layerList: [],
      layerNoList: []
    }
  },
  computed: {
    columns () {
      return [
        {
          title: '序号',
          width: 65,
          align: 'center',
          type: 'index'
        },
        {
          title: '病例编号',
          align: 'center',
          sortable: true,
          key: 'pathology_id'
        },
        {
          title: '玻片编号',
          sortable: true,
          key: 'slide_code'
        },
        {
          title: '创建时间',
          sortable: true,
          align: 'center',
          width: 180,
          key: 'create_dt'
        },
        {
          title: '操作',
          align: 'center',
          width: 180,
          key: 'create_dt',
          render: (h, row) => {
            if (row.row.slide_id === undefined) {
              return h('div', this.$t('slideTable.noSlides'))
            }
            return h('div', [
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {},
                on: {
                  click: () => {
                    this.printSlideQrCode(row.row.slide_id)
                  }
                }
              }, '打印条码')
            ])
          }
        }
      ]
    }
  },
  beforeMount () {
    this.$vue = this
    this.getLayerList()
    this.getLayerNoList()
  },
  methods: {
    // 获取玻片列表
    async getLayerList () {
      this.showLoading = true
      let params = new URLSearchParams()
      params.append('pageSize', this.pageSize.toString())
      params.append('pageNum', this.pageNum.toString())
      let suc = await this.$http.post(this.$vue.getData('GET_NOSCAN_LAYERLIST_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        this.layerList = data.list
        this.total = data.total
      }
      this.showLoading = false
    },
    async getLayerNoList () {
      this.showLoading = true
      let params = new URLSearchParams()
      params.append('pageSize', this.pageSize1.toString())
      params.append('pageNum', this.pageNum1.toString())
      let suc = await this.$http.post(this.$vue.getData('GET_ERROR_LAYERLIST_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        this.layerNoList = data.list
        this.total1 = data.total
      }
      this.showLoading = false
    },
    // 导出Excel
    exportToExcel () {
      this.$refs.table.exportCsv({
        filename: '未扫描病例',
        original: false,
        columns: this.columns.filter((col, index) => index > 0 && index < 3),
        data: this.layerList.filter((data, index) => index < this.layerList.length)
      })
    },
    // 导出Excel
    exportToExcel1 () {
      this.$refs.table.exportCsv({
        filename: '分析失败病例',
        original: false,
        columns: this.columns.filter((col, index) => index > 0 && index < 3),
        data: this.layerNoList.filter((data, index) => index < this.layerNoList.length)
      })
    },
    // 页码改变时，回调方法
    pageNumChange (pageNum) {
      this.pageNum = pageNum
      // 重新获取列表
      this.getLayerList()
    },
    // 每页条数改变时回调方法
    onPageSizeChange (pageSize) {
      this.pageSize = pageSize
      // 重新获取列表
      this.getLayerList()
    },
    // 页码改变时，回调方法
    pageNumChange1 (pageNum) {
      this.pageNum1 = pageNum
      // 重新获取列表
      this.getLayerNoList()
    },
    // 每页条数改变时回调方法
    onPageSizeChange1 (pageSize) {
      this.pageSize1 = pageSize
      // 重新获取列表
      this.getLayerNoList()
    },
    // 打印玻片二维码
    async printSlideQrCode (slideId) {
      let params = new URLSearchParams()
      params.append('slideId', slideId)
      params.append('userInfoId', localStorage.getItem('userId' + localStorage.getItem('userName')))
      let suc = await this.$http.post(this.$vue.getData('PRINT_SLIDE_QRCODE_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        let IsMoreSlides = data.length > 1 ? 'true' : 'false'
        for (let i = 0; i < data.length; i++) {
          let item = data[i]
          let code = ''
          if (IsMoreSlides) {
            code = item.slide_code
          } else {
            code = item.pathology_id
          }
          let qrcode = '@' + item.slide_id
          try {
            window.HandleEvent('print', code, qrcode)
          } catch (e) {
            console.log('请配合最新智能诊断系统使用')
          }
        }
      }
      console.log(suc)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .page
    margin-top 10px
    text-align right
  .over-width
    position relative
    white-space nowrap /* 溢出不换行 */
    overflow hidden
    text-overflow ellipsis
</style>



// WEBPACK FOOTER //
// src/components/base/table/LayerTable.vue